var map = {
	"./365-and-datacamp-comparisson.png": 1835,
	"./365-logo-small-light.png": 1553,
	"./365-logo-small.png": 1836,
	"./about-us-companies.png": 1466,
	"./about-us-our-vision.png": 1468,
	"./about-us-ready-bg.png": 1837,
	"./about-us-students.png": 1838,
	"./about-us.jpg": 1839,
	"./advanced-specialization.png": 1840,
	"./alternative-page.png": 1841,
	"./b2b-img1.jpg": 1493,
	"./b2b-img1.png": 1842,
	"./b2b-img2.jpg": 1494,
	"./b2b-img2.png": 1843,
	"./b2b-img3.jpg": 1495,
	"./b2b-img3.png": 1844,
	"./b2b-img4.jpg": 1496,
	"./b2b-img4.png": 1845,
	"./b2b-img5.jpg": 1497,
	"./b2b-img5.png": 1846,
	"./b2b-img6.jpg": 1498,
	"./b2b-img6.png": 1847,
	"./b2b-preview-image-mobile.jpg": 1486,
	"./b2b-preview-image.jpg": 1484,
	"./background-scholarship-page.jpg": 1848,
	"./bf-background-desktop.jpg": 1849,
	"./bf-background-mobile.jpg": 1850,
	"./blog-banner-users-light.png": 1554,
	"./blog-banner-users-mobile.png": 1555,
	"./blog-banner-users.png": 1851,
	"./business-live-trainings-mobile.png": 1479,
	"./business-live-trainings.png": 1478,
	"./calculators/coefficient-of-variation/cov-01-faq-desktop.png": 1556,
	"./calculators/coefficient-of-variation/cov-02-faq-desktop.png": 1557,
	"./calculators/coefficient-of-variation/cov-03-faq-desktop.png": 1558,
	"./calculators/coefficient-of-variation/cov-04-faq-desktop.png": 1559,
	"./calculators/coefficient-of-variation/cov-05-faq-desktop.png": 1560,
	"./calculators/confidence-interval/confidence-interval-01-desktop.png": 1561,
	"./calculators/confidence-interval/confidence-interval-02-desktop.png": 1562,
	"./calculators/confidence-interval/confidence-interval-03-desktop.png": 1563,
	"./calculators/confidence-interval/confidence-interval-04-desktop.webp": 1564,
	"./calculators/confidence-interval/confidence-interval-05-desktop.png": 1565,
	"./calculators/confidence-interval/confidence-interval-06-desktop.webp": 1566,
	"./calculators/confidence-interval/confidence-interval-07-desktop.png": 1567,
	"./calculators/difference-in-means/dif-in-means-001.webp": 1568,
	"./calculators/difference-in-means/dif-in-means-02-mobile.webp": 1569,
	"./calculators/difference-in-means/dif-in-means-02.webp": 1570,
	"./calculators/difference-in-means/dif-in-means-faq-01.webp": 1571,
	"./calculators/difference-in-means/dif-in-means-faq-02.webp": 1572,
	"./calculators/difference-in-means/dif-in-means-faq-03.webp": 1573,
	"./calculators/difference-in-means/dif-in-means-faq-04.webp": 1574,
	"./calculators/difference-in-means/dif-in-means-faq-05.webp": 1575,
	"./calculators/difference-in-means/dif-in-means-faq-06.webp": 1576,
	"./calculators/difference-in-means/dif-in-means-faq-07.webp": 1577,
	"./calculators/hypothesis-test/hypothesis-test-002.webp": 1578,
	"./calculators/hypothesis-test/hypothesis-test-01.webp": 1579,
	"./calculators/hypothesis-test/hypothesis-test-03.webp": 1580,
	"./calculators/hypothesis-test/hypothesis-test-04-07.webp": 1433,
	"./calculators/hypothesis-test/hypothesis-test-05.webp": 1581,
	"./calculators/hypothesis-test/hypothesis-test-06.webp": 1582,
	"./calculators/hypothesis-test/hypothesis-test-08.webp": 1583,
	"./calculators/hypothesis-test/hypothesis-test-09.webp": 1584,
	"./calculators/hypothesis-test/hypothesis-test-11.webp": 1585,
	"./calculators/hypothesis-test/hypothesis-test-12-13.webp": 1434,
	"./calculators/hypothesis-test/hypothesis-test-14.webp": 1586,
	"./calculators/hypothesis-test/hypothesis-test-15.webp": 1587,
	"./calculators/hypothesis-test/hypothesis-test-16.webp": 1588,
	"./calculators/hypothesis-test/hypothesis-test-17.webp": 1589,
	"./calculators/hypothesis-test/hypothesis-test2-10.webp": 1590,
	"./calculators/kurtosis/kurtosis-01-desktop.png": 1591,
	"./calculators/kurtosis/kurtosis-02-desktop.png": 1592,
	"./calculators/kurtosis/kurtosis-03-desktop.png": 1593,
	"./calculators/kurtosis/kurtosis-04-desktop.png": 1594,
	"./calculators/kurtosis/kurtosis-05-desktop.png": 1595,
	"./calculators/kurtosis/kurtosis-07-desktop.png": 1596,
	"./calculators/kurtosis/kurtosis-08-desktop.png": 1597,
	"./calculators/kurtosis/kurtosis-faq-01-desktop.png": 1598,
	"./calculators/kurtosis/kurtosis-faq-02-desktop.png": 1599,
	"./calculators/kurtosis/kurtosis-faq-03-desktop.png": 1600,
	"./calculators/kurtosis/kurtosis2-06-desktop.png": 1601,
	"./calculators/linear-regression/linear-regression-01.webp": 1602,
	"./calculators/linear-regression/linear-regression-02.webp": 1603,
	"./calculators/linear-regression/linear-regression-03.webp": 1604,
	"./calculators/linear-regression/linear-regression-04.webp": 1605,
	"./calculators/linear-regression/linear-regression-05.webp": 1606,
	"./calculators/linear-regression/linear-regression-06.webp": 1607,
	"./calculators/linear-regression/linear-regression-08.webp": 1608,
	"./calculators/linear-regression/linear-regression-09.webp": 1609,
	"./calculators/linear-regression/linear-regression-10.webp": 1610,
	"./calculators/linear-regression/linear-regression-11.webp": 1611,
	"./calculators/linear-regression/linear-regression-12.webp": 1612,
	"./calculators/linear-regression/linear-regression-13.webp": 1613,
	"./calculators/linear-regression/linear-regression-14.webp": 1614,
	"./calculators/linear-regression/linear-regression-15.webp": 1615,
	"./calculators/linear-regression/linear-regression-16.webp": 1616,
	"./calculators/linear-regression/linear-regression-17.webp": 1617,
	"./calculators/linear-regression/linear-regression-18.webp": 1618,
	"./calculators/linear-regression/linear-regression-19.webp": 1619,
	"./calculators/linear-regression/linear-regression-20.webp": 1620,
	"./calculators/linear-regression/linear-regression-21.webp": 1621,
	"./calculators/linear-regression/linear-regression-22.webp": 1622,
	"./calculators/linear-regression/linear-regression-24.webp": 1623,
	"./calculators/linear-regression/linear-regression-25.webp": 1624,
	"./calculators/linear-regression/linear-regression2-07.webp": 1625,
	"./calculators/linear-regression/linear-regression2-23.webp": 1626,
	"./calculators/linear-regression/watermark.png": 1627,
	"./calculators/mean-median-mode/mmm-01-desktop.png": 1628,
	"./calculators/mean-median-mode/mmm-02-desktop.png": 1629,
	"./calculators/mean-median-mode/mmm-03-desktop.png": 1630,
	"./calculators/mean-median-mode/mmm-04-desktop.png": 1631,
	"./calculators/mean-median-mode/mmm-05-desktop.png": 1632,
	"./calculators/mean-median-mode/mmm-06-desktop.png": 1633,
	"./calculators/mean-median-mode/mmm-07-desktop.png": 1634,
	"./calculators/mean-median-mode/mmm-faq-01-desktop.png": 1635,
	"./calculators/mean-median-mode/mmm-faq-02-desktop.png": 1636,
	"./calculators/mean-median-mode/mmm-faq-03-desktop.png": 1637,
	"./calculators/mean-median-mode/mmm-faq-04-desktop.png": 1638,
	"./calculators/mean-median-mode/mmm-faq-05-desktop.png": 1639,
	"./calculators/mean-median-mode/mmm-faq-06-desktop.png": 1640,
	"./calculators/mean-median-mode/mmm-faq-07-desktop.png": 1641,
	"./calculators/p-value/p-value-01.webp": 1642,
	"./calculators/p-value/p-value-02.webp": 1643,
	"./calculators/p-value/p-value-03.webp": 1644,
	"./calculators/p-value/p-value-04.webp": 1645,
	"./calculators/p-value/p-value-05.webp": 1852,
	"./calculators/p-value/p-value-10-mobile.webp": 1646,
	"./calculators/p-value/p-value-10.webp": 1647,
	"./calculators/p-value/p-value-12-mobile.webp": 1648,
	"./calculators/p-value/p-value-12.webp": 1649,
	"./calculators/p-value/p-value1-06.webp": 1650,
	"./calculators/p-value/p-value1-07.webp": 1651,
	"./calculators/p-value/p-value1-08.webp": 1652,
	"./calculators/p-value/p-value1-09.webp": 1653,
	"./calculators/p-value/p-value1-11-mobile.webp": 1654,
	"./calculators/p-value/p-value1-11.webp": 1655,
	"./calculators/skewness/skewness-01-desktop.png": 1656,
	"./calculators/skewness/skewness-01-faq-desktop.png": 1657,
	"./calculators/skewness/skewness-02-desktop.png": 1658,
	"./calculators/skewness/skewness-02-faq-desktop.png": 1659,
	"./calculators/skewness/skewness-03-desktop.png": 1660,
	"./calculators/skewness/skewness-03-faq-desktop.png": 1661,
	"./calculators/skewness/skewness-04-faq-desktop.png": 1662,
	"./calculators/skewness/skewness-05-desktop.png": 1663,
	"./calculators/skewness/skewness-05-faq-desktop.png": 1664,
	"./calculators/skewness/skewness-06-desktop.png": 1665,
	"./calculators/skewness/skewness-06-faq-desktop.png": 1666,
	"./calculators/skewness/skewness-07-desktop.png": 1667,
	"./calculators/skewness/skewness-07-faq-desktop.png": 1668,
	"./calculators/skewness/skewness-08-desktop.png": 1669,
	"./calculators/skewness/skewness-09-desktop.png": 1670,
	"./calculators/skewness/skewness-10-desktop.png": 1671,
	"./calculators/skewness/skewness-11-desktop.png": 1672,
	"./calculators/skewness/skewness-12-desktop.png": 1673,
	"./calculators/skewness/skewness-13-desktop.png": 1674,
	"./calculators/skewness/skewness-14-desktop.png": 1675,
	"./calculators/skewness/skewness-15-desktop.png": 1676,
	"./calculators/skewness/skewness-16-desktop.png": 1677,
	"./calculators/skewness/skewness-17-desktop.png": 1678,
	"./calculators/skewness/skewness2-04-desktop.png": 1679,
	"./calculators/skewness/zoomed-first.png": 1680,
	"./calculators/skewness/zoomed-second.png": 1681,
	"./calculators/standard-deviation/sd-01-faq-desktop.png": 1682,
	"./calculators/standard-deviation/sd-02-desktop.png": 1683,
	"./calculators/standard-deviation/sd-02-faq-desktop.png": 1684,
	"./calculators/standard-deviation/sd-03-desktop.png": 1685,
	"./calculators/standard-deviation/sd-03-faq-desktop.png": 1686,
	"./calculators/standard-deviation/sd-04-desktop.png": 1687,
	"./calculators/standard-deviation/sd-04-faq-desktop.png": 1688,
	"./calculators/standard-deviation/sd-05-desktop.png": 1689,
	"./calculators/standard-deviation/sd-05-faq-desktop.png": 1690,
	"./calculators/standard-deviation/sd2-01-desktop.png": 1691,
	"./calculators/standard-deviation/sd2-06-desktop.png": 1692,
	"./campaigns/bf-landing/blog-banner.png": 1061,
	"./campaigns/bf-landing/cards.jpg": 1062,
	"./campaigns/bf-landing/career-tracks.jpg": 1063,
	"./campaigns/bf-landing/certificates.jpg": 1064,
	"./campaigns/bf-landing/exams.jpg": 1065,
	"./campaigns/bf-landing/foot-glitches.png": 1066,
	"./campaigns/bf-landing/hero-glitches.png": 1067,
	"./campaigns/bf-landing/instructors/anastasia.jpg": 1068,
	"./campaigns/bf-landing/instructors/andrew.jpg": 1069,
	"./campaigns/bf-landing/instructors/bernard.jpg": 1070,
	"./campaigns/bf-landing/instructors/danielle.jpg": 1071,
	"./campaigns/bf-landing/instructors/davis.jpg": 1072,
	"./campaigns/bf-landing/instructors/elitsa.jpg": 1073,
	"./campaigns/bf-landing/instructors/giles.jpg": 1074,
	"./campaigns/bf-landing/instructors/harpreet.jpg": 1075,
	"./campaigns/bf-landing/instructors/ken.jpg": 1076,
	"./campaigns/bf-landing/instructors/olivier.jpg": 1077,
	"./campaigns/bf-landing/instructors/randy.jpg": 1078,
	"./campaigns/bf-landing/instructors/tina.jpg": 1079,
	"./campaigns/bf-landing/leaderboard.jpg": 1080,
	"./campaigns/bf-landing/sticky-banner-bg.png": 1081,
	"./campaigns/bf-landing/video-thumb-ahmed.jpg": 1082,
	"./campaigns/bf-landing/video-thumb-ernest.jpg": 1083,
	"./campaigns/bf-landing/video-thumb-lee.jpg": 1084,
	"./campaigns/bf-landing/video-thumb-meghan.jpg": 1085,
	"./campaigns/bf-landing/video-thumb-nada.jpg": 1086,
	"./campaigns/bf-landing/xp-coins.jpg": 1087,
	"./campaigns/cm-banners/cm-blog-banner-visuals-1.png": 973,
	"./campaigns/cm-banners/cm-blog-banner-visuals-2.png": 974,
	"./campaigns/cm-banners/cm-blog-banner-visuals-3.png": 975,
	"./campaigns/cm-banners/cm-blog-banner-visuals-4.png": 976,
	"./campaigns/cm-banners/cyber-monday-blog-banner.png": 977,
	"./campaigns/cm-ext-label-mobile.webp": 707,
	"./campaigns/cm-ext-label.webp": 578,
	"./campaigns/cyber-monday-landing/backgrounds/banner-bg.jpg": 1088,
	"./campaigns/cyber-monday-landing/backgrounds/card-bg.png": 1089,
	"./campaigns/cyber-monday-landing/backgrounds/cm-hero-bg1-mobile.png": 1090,
	"./campaigns/cyber-monday-landing/backgrounds/cm-hero-bg2-mobile.png": 1091,
	"./campaigns/cyber-monday-landing/backgrounds/curriculum-bg-mobile.png": 1092,
	"./campaigns/cyber-monday-landing/backgrounds/curriculum-bg.jpg": 1093,
	"./campaigns/cyber-monday-landing/backgrounds/footer-bg-mobile.png": 1094,
	"./campaigns/cyber-monday-landing/backgrounds/footer-bg.jpg": 1095,
	"./campaigns/cyber-monday-landing/backgrounds/header-bg.png": 1096,
	"./campaigns/cyber-monday-landing/backgrounds/video-bg-mobile.png": 1097,
	"./campaigns/cyber-monday-landing/backgrounds/video-bg.jpg": 1098,
	"./campaigns/cyber-monday-landing/cm-cards.jpg": 1099,
	"./campaigns/cyber-monday-landing/cm-career-tracks.jpg": 1100,
	"./campaigns/cyber-monday-landing/cm-certificates.jpg": 1101,
	"./campaigns/cyber-monday-landing/cm-exams.jpg": 1102,
	"./campaigns/cyber-monday-landing/cm-leaderboard.jpg": 1103,
	"./campaigns/cyber-monday-landing/cm-xp-coins.jpg": 1104,
	"./campaigns/ds-bf-bg-blog-banner.webp": 657,
	"./campaigns/ds-bf-bg-bottom-banner.webp": 708,
	"./campaigns/ds-bf-bg-footer-mobile2.webp": 723,
	"./campaigns/ds-bf-bg-footer.webp": 724,
	"./campaigns/ds-bf-bg-hero-mobile.webp": 725,
	"./campaigns/ds-bf-bg-hero.webp": 726,
	"./campaigns/ds-bf-certificate.webp": 727,
	"./campaigns/ds-bf-channels.webp": 728,
	"./campaigns/ds-bf-clp.webp": 729,
	"./campaigns/ds-bf-exams.webp": 730,
	"./campaigns/ds-bf-leaderboard.webp": 731,
	"./campaigns/ds-bf-projects.webp": 732,
	"./campaigns/ds-bf-resume.webp": 733,
	"./campaigns/ds-bf-title-benefit-mobile.webp": 734,
	"./campaigns/ds-bf-title-benefit.webp": 700,
	"./campaigns/ds-bf-title-courses-mobile.webp": 698,
	"./campaigns/ds-bf-title-courses.webp": 696,
	"./campaigns/ds-bf-title-hero-mobile.webp": 695,
	"./campaigns/ds-bf-title-hero.webp": 577,
	"./campaigns/ds-bf-title-offer.webp": 705,
	"./campaigns/ds-bf-title-projects-mobile.webp": 703,
	"./campaigns/ds-bf-title-projects.webp": 702,
	"./campaigns/ds-bf-tracks.webp": 735,
	"./campaigns/ds-cm-bg-blog-banner.webp": 658,
	"./campaigns/ds-cm-bg-bottom-banner.webp": 659,
	"./campaigns/ds-cm-bg-footer-mobile.webp": 736,
	"./campaigns/ds-cm-bg-footer.webp": 737,
	"./campaigns/ds-cm-bg-hero-mobile.webp": 738,
	"./campaigns/ds-cm-bg-hero.webp": 739,
	"./campaigns/ds-cm-bg-page-laptop.webp": 740,
	"./campaigns/ds-cm-bg-page-mobile.webp": 741,
	"./campaigns/ds-cm-bg-page.webp": 742,
	"./campaigns/ds-cm-certificate.webp": 743,
	"./campaigns/ds-cm-channels.webp": 744,
	"./campaigns/ds-cm-clp.webp": 745,
	"./campaigns/ds-cm-exams.webp": 746,
	"./campaigns/ds-cm-leaderboard.webp": 747,
	"./campaigns/ds-cm-projects.webp": 748,
	"./campaigns/ds-cm-resume.webp": 749,
	"./campaigns/ds-cm-title-benefit.webp": 660,
	"./campaigns/ds-cm-title-courses-mobile.webp": 661,
	"./campaigns/ds-cm-title-courses.webp": 662,
	"./campaigns/ds-cm-title-hero-mobile.webp": 663,
	"./campaigns/ds-cm-title-hero2.webp": 602,
	"./campaigns/ds-cm-title-offer.webp": 664,
	"./campaigns/ds-cm-title-projects-mobile.webp": 665,
	"./campaigns/ds-cm-title-projects.webp": 666,
	"./campaigns/ds-cm-tracks.webp": 750,
	"./campaigns/ds-cm-xp.webp": 751,
	"./campaigns/ds-cme-bg-blog-banner.webp": 667,
	"./campaigns/ds-cme-certificate.webp": 752,
	"./campaigns/ds-cme-channels.webp": 753,
	"./campaigns/ds-cme-clp.webp": 754,
	"./campaigns/ds-cme-exams.webp": 755,
	"./campaigns/ds-cme-leaderboard.webp": 756,
	"./campaigns/ds-cme-projects.webp": 757,
	"./campaigns/ds-cme-resume.webp": 758,
	"./campaigns/ds-cme-tracks.webp": 759,
	"./campaigns/ds-cme-xp.webp": 760,
	"./campaigns/ds-fw-bg-bottom-banner.webp": 709,
	"./campaigns/ds-fw-bg-footer-final.webp": 761,
	"./campaigns/ds-fw-bg-footer-mobile-final.webp": 762,
	"./campaigns/ds-fw-bg-hero-mobile-final.webp": 763,
	"./campaigns/ds-fw-bg-hero.webp": 764,
	"./campaigns/ds-fw-blog-banner.webp": 668,
	"./campaigns/ds-fw-certificate.webp": 765,
	"./campaigns/ds-fw-channels.webp": 766,
	"./campaigns/ds-fw-clp.webp": 767,
	"./campaigns/ds-fw-exams.webp": 768,
	"./campaigns/ds-fw-leaderboard.webp": 769,
	"./campaigns/ds-fw-projects.webp": 770,
	"./campaigns/ds-fw-resume.webp": 771,
	"./campaigns/ds-fw-tracks.webp": 772,
	"./campaigns/ds-fw-xp.webp": 773,
	"./campaigns/fa-bf-bg-bottom-banner.webp": 710,
	"./campaigns/fa-bf-bg-footer-mobile2.webp": 774,
	"./campaigns/fa-bf-bg-footer.webp": 775,
	"./campaigns/fa-bf-bg-hero-mobile.webp": 776,
	"./campaigns/fa-bf-bg-hero.webp": 777,
	"./campaigns/fa-bf-certificate.webp": 778,
	"./campaigns/fa-bf-channels.webp": 779,
	"./campaigns/fa-bf-clp.webp": 780,
	"./campaigns/fa-bf-exams.webp": 781,
	"./campaigns/fa-bf-hero-title-mobile.webp": 782,
	"./campaigns/fa-bf-hero-title.webp": 783,
	"./campaigns/fa-bf-leaderboard.webp": 784,
	"./campaigns/fa-bf-projects.webp": 785,
	"./campaigns/fa-bf-resume.webp": 786,
	"./campaigns/fa-bf-title-benefit-mobile.webp": 787,
	"./campaigns/fa-bf-title-benefit.webp": 701,
	"./campaigns/fa-bf-title-courses-mobile.webp": 699,
	"./campaigns/fa-bf-title-courses.webp": 697,
	"./campaigns/fa-bf-title-hero-mobile.webp": 788,
	"./campaigns/fa-bf-title-hero.webp": 603,
	"./campaigns/fa-bf-title-offer.webp": 706,
	"./campaigns/fa-bf-title-reviews.webp": 704,
	"./campaigns/fa-bf-tracks.webp": 789,
	"./campaigns/fa-bf-xp.webp": 790,
	"./campaigns/fa-cm-bg-bottom-banner.webp": 669,
	"./campaigns/fa-cm-bg-footer-mobile.webp": 791,
	"./campaigns/fa-cm-bg-footer.webp": 792,
	"./campaigns/fa-cm-bg-hero-mobile.webp": 793,
	"./campaigns/fa-cm-bg-hero.webp": 794,
	"./campaigns/fa-cm-certificate.webp": 795,
	"./campaigns/fa-cm-channels.webp": 796,
	"./campaigns/fa-cm-clp.webp": 797,
	"./campaigns/fa-cm-exams.webp": 798,
	"./campaigns/fa-cm-leaderboard.webp": 799,
	"./campaigns/fa-cm-projects.webp": 800,
	"./campaigns/fa-cm-resume.webp": 801,
	"./campaigns/fa-cm-title-benefit.webp": 670,
	"./campaigns/fa-cm-title-courses-mobile.webp": 671,
	"./campaigns/fa-cm-title-courses.webp": 672,
	"./campaigns/fa-cm-title-hero-mobile.webp": 673,
	"./campaigns/fa-cm-title-hero2.webp": 604,
	"./campaigns/fa-cm-title-offer.webp": 674,
	"./campaigns/fa-cm-title-reviews.webp": 675,
	"./campaigns/fa-cm-tracks.webp": 802,
	"./campaigns/fa-cm-xp.webp": 803,
	"./campaigns/fa-cme-certificate.webp": 804,
	"./campaigns/fa-cme-channels.webp": 805,
	"./campaigns/fa-cme-clp.webp": 806,
	"./campaigns/fa-cme-exams.webp": 807,
	"./campaigns/fa-cme-leaderboard.webp": 808,
	"./campaigns/fa-cme-projects.webp": 809,
	"./campaigns/fa-cme-resume.webp": 810,
	"./campaigns/fa-cme-tracks.webp": 811,
	"./campaigns/fa-cme-xp.webp": 812,
	"./campaigns/fa-fw-bg-bottom-banner.webp": 711,
	"./campaigns/fa-fw-bg-footer-final.webp": 813,
	"./campaigns/fa-fw-bg-footer-mobile-final.webp": 814,
	"./campaigns/fa-fw-bg-hero-mobile-final.webp": 815,
	"./campaigns/fa-fw-bg-hero.webp": 816,
	"./campaigns/fa-fw-certificate.webp": 817,
	"./campaigns/fa-fw-channels.webp": 818,
	"./campaigns/fa-fw-clp.webp": 819,
	"./campaigns/fa-fw-exams.webp": 820,
	"./campaigns/fa-fw-leaderboard.webp": 821,
	"./campaigns/fa-fw-projects.webp": 822,
	"./campaigns/fa-fw-resume.webp": 823,
	"./campaigns/fa-fw-tracks.webp": 824,
	"./campaigns/fa-fw-xp.webp": 825,
	"./campaigns/finance-courses-offer-landing/fc-card-bg.png": 1105,
	"./campaigns/finance-courses-offer-landing/fc-cards.jpg": 1106,
	"./campaigns/finance-courses-offer-landing/fc-career-tracks.jpg": 1107,
	"./campaigns/finance-courses-offer-landing/fc-certificates.jpg": 1108,
	"./campaigns/finance-courses-offer-landing/fc-coins.jpg": 1109,
	"./campaigns/finance-courses-offer-landing/fc-exams.jpg": 1110,
	"./campaigns/finance-courses-offer-landing/fc-footer-bg-mobile.png": 1111,
	"./campaigns/finance-courses-offer-landing/fc-footer-bg.jpg": 1112,
	"./campaigns/finance-courses-offer-landing/fc-footer-bottom.jpg": 1113,
	"./campaigns/finance-courses-offer-landing/fc-footer-top.png": 1114,
	"./campaigns/finance-courses-offer-landing/fc-leaderboard.jpg": 1115,
	"./campaigns/finance-courses-offer-landing/fc-newsfeed.jpg": 1116,
	"./campaigns/finance-courses-offer-landing/fc-program-stats-bg.jpg": 1117,
	"./campaigns/finance-courses-offer-landing/fc-program-stats-mobile-bg.png": 1118,
	"./campaigns/finance-courses-offer-landing/fc-streaks.jpg": 1119,
	"./campaigns/finance-courses-offer-landing/fc-video-bg.jpg": 1120,
	"./campaigns/finance-courses-offer-landing/fc-xp.jpg": 1121,
	"./campaigns/finance-courses-offer-landing/hero-bg1-mobile.png": 1122,
	"./campaigns/finance-courses-offer-landing/hero-bg2-mobile.png": 1123,
	"./campaigns/future-proof/c-fpc-cards.webp": 826,
	"./campaigns/future-proof/c-fpc-certificates.webp": 827,
	"./campaigns/future-proof/c-fpc-exams.webp": 828,
	"./campaigns/future-proof/c-fpc-leaderboard.webp": 829,
	"./campaigns/future-proof/c-fpc-tracks.webp": 830,
	"./campaigns/future-proof/c-fpc-xp.webp": 831,
	"./campaigns/future-proof/fpc-bg-bottom-banner.webp": 832,
	"./campaigns/future-proof/fpc-bg-footer-mobile.webp": 833,
	"./campaigns/future-proof/fpc-bg-footer.webp": 834,
	"./campaigns/future-proof/fpc-bg-hero-mobile.webp": 835,
	"./campaigns/future-proof/fpc-bg-hero.webp": 836,
	"./campaigns/future-proof/fpc-proof-bg-blog.webp": 837,
	"./campaigns/get-future-ready/dsgfr-bg-blog.webp": 838,
	"./campaigns/get-future-ready/dsgfr-bg-bottom-banner.webp": 839,
	"./campaigns/get-future-ready/dsgfr-bg-footer-mobile.webp": 840,
	"./campaigns/get-future-ready/dsgfr-bg-footer.webp": 841,
	"./campaigns/get-future-ready/dsgfr-bg-hero-mobile.webp": 842,
	"./campaigns/get-future-ready/dsgfr-bg-hero.webp": 843,
	"./campaigns/get-future-ready/dsgfr-certificate.webp": 844,
	"./campaigns/get-future-ready/dsgfr-channels.webp": 845,
	"./campaigns/get-future-ready/dsgfr-clp.webp": 846,
	"./campaigns/get-future-ready/dsgfr-exams.webp": 847,
	"./campaigns/get-future-ready/dsgfr-leaderboard.webp": 848,
	"./campaigns/get-future-ready/dsgfr-projects.webp": 849,
	"./campaigns/get-future-ready/dsgfr-resume.webp": 850,
	"./campaigns/get-future-ready/dsgfr-technologies-mobile.webp": 851,
	"./campaigns/get-future-ready/dsgfr-technologies.webp": 852,
	"./campaigns/get-future-ready/dsgfr-tracks.webp": 853,
	"./campaigns/get-future-ready/dsgfr-xp.webp": 854,
	"./campaigns/get-future-ready/gfr-bg-bottom-banner.webp": 855,
	"./campaigns/get-future-ready/gfr-bg-footer-mobile-new.webp": 856,
	"./campaigns/get-future-ready/gfr-bg-footer.webp": 857,
	"./campaigns/get-future-ready/gfr-bg-hero-mobile.webp": 858,
	"./campaigns/get-future-ready/gfr-bg-hero.webp": 859,
	"./campaigns/get-future-ready/gfr-cards.webp": 860,
	"./campaigns/get-future-ready/gfr-certificate.webp": 861,
	"./campaigns/get-future-ready/gfr-channels.webp": 862,
	"./campaigns/get-future-ready/gfr-clp.webp": 863,
	"./campaigns/get-future-ready/gfr-coins.webp": 864,
	"./campaigns/get-future-ready/gfr-exams.webp": 865,
	"./campaigns/get-future-ready/gfr-leaderboard.webp": 866,
	"./campaigns/get-future-ready/gfr-projects.webp": 867,
	"./campaigns/get-future-ready/gfr-streak.webp": 868,
	"./campaigns/get-future-ready/gfr-tracks.webp": 869,
	"./campaigns/get-future-ready/gfr-xp.webp": 870,
	"./campaigns/got-what-it-takes-landing/gwt-blog-banner-bg.jpg": 1124,
	"./campaigns/got-what-it-takes-landing/gwt-cards.jpg": 1125,
	"./campaigns/got-what-it-takes-landing/gwt-career-tracks.jpg": 1126,
	"./campaigns/got-what-it-takes-landing/gwt-certificates.jpg": 1127,
	"./campaigns/got-what-it-takes-landing/gwt-exams.jpg": 1128,
	"./campaigns/got-what-it-takes-landing/gwt-leaderboard.jpg": 1129,
	"./campaigns/got-what-it-takes-landing/gwt-quiz-background.jpg": 1130,
	"./campaigns/got-what-it-takes-landing/gwt-quiz-mobile-bg.jpg": 1131,
	"./campaigns/got-what-it-takes-landing/gwt-sticky-banner.jpg": 1132,
	"./campaigns/got-what-it-takes-landing/gwt-xp-coins.jpg": 1133,
	"./campaigns/instructors/instr-anastasia.jpg": 1007,
	"./campaigns/instructors/instr-andrew.jpg": 1008,
	"./campaigns/instructors/instr-bernard.jpg": 1009,
	"./campaigns/instructors/instr-danielle.jpg": 1010,
	"./campaigns/instructors/instr-davis.jpg": 1011,
	"./campaigns/instructors/instr-elitsa.jpg": 1012,
	"./campaigns/instructors/instr-giles.jpg": 1013,
	"./campaigns/instructors/instr-harpreet.jpg": 1014,
	"./campaigns/instructors/instr-ken.jpg": 1015,
	"./campaigns/instructors/instr-olivier.jpg": 1016,
	"./campaigns/instructors/instr-randy.jpg": 1017,
	"./campaigns/instructors/instr-tina.jpg": 1018,
	"./campaigns/jumpstart-2023-landing/js-cards.jpg": 1134,
	"./campaigns/jumpstart-2023-landing/js-career-tracks.jpg": 1135,
	"./campaigns/jumpstart-2023-landing/js-certificates.jpg": 1136,
	"./campaigns/jumpstart-2023-landing/js-exams.jpg": 1137,
	"./campaigns/jumpstart-2023-landing/js-leaderboard.jpg": 1138,
	"./campaigns/jumpstart-2023-landing/js-xp-coins.jpg": 1139,
	"./campaigns/jumpstart-2023-landing/jumpstart-blog-banner.jpg": 1140,
	"./campaigns/jumpstart-2023-landing/jumpstart-footer-bg-mobile.png": 1141,
	"./campaigns/jumpstart-2023-landing/jumpstart-footer-bg.jpg": 1142,
	"./campaigns/jumpstart-2023-landing/jumpstart-hero-bg-mobile.png": 1143,
	"./campaigns/jumpstart-2023-landing/jumpstart-hero-bg.jpg": 1144,
	"./campaigns/jumpstart-2023-landing/jumpstart-sticky-banner-bg-1920.jpg": 1145,
	"./campaigns/jumpstart-2023-landing/jumpstart-sticky-banner-bg.jpg": 1146,
	"./campaigns/jumpstart-2023-landing/lightning-mobile.png": 1147,
	"./campaigns/jumpstart-2023-landing/lightning.png": 1148,
	"./campaigns/one-of-200-landing/oth-blog-banner-bg.jpg": 1149,
	"./campaigns/one-of-200-landing/oth-cards.jpg": 1150,
	"./campaigns/one-of-200-landing/oth-career-tracks.jpg": 1151,
	"./campaigns/one-of-200-landing/oth-certificates.jpg": 1152,
	"./campaigns/one-of-200-landing/oth-exams.jpg": 1153,
	"./campaigns/one-of-200-landing/oth-leaderboard.jpg": 1154,
	"./campaigns/one-of-200-landing/oth-sticky-banner-bg.jpg": 1155,
	"./campaigns/one-of-200-landing/oth-xp-coins.jpg": 1156,
	"./campaigns/top-finance-training/lightning2-mobile.jpg": 1157,
	"./campaigns/top-finance-training/lightning2.jpg": 1158,
	"./campaigns/top-finance-training/tft-bottom-banner-bg-laptop-last-promo.webp": 871,
	"./campaigns/top-finance-training/tft-bottom-banner-bg-laptop.webp": 872,
	"./campaigns/top-finance-training/tft-bottom-banner-bg-last-promo.webp": 873,
	"./campaigns/top-finance-training/tft-bottom-banner-bg.webp": 874,
	"./campaigns/top-finance-training/tft-cards.webp": 875,
	"./campaigns/top-finance-training/tft-certificates.webp": 876,
	"./campaigns/top-finance-training/tft-coins.webp": 877,
	"./campaigns/top-finance-training/tft-exams.webp": 878,
	"./campaigns/top-finance-training/tft-footer-bg-mobile.webp": 879,
	"./campaigns/top-finance-training/tft-footer-bg.jpg": 1159,
	"./campaigns/top-finance-training/tft-hero-bg.jpg": 1160,
	"./campaigns/top-finance-training/tft-hero-mobile-bg.webp": 880,
	"./campaigns/top-finance-training/tft-leaderboard.webp": 881,
	"./campaigns/top-finance-training/tft-newsfeed.webp": 882,
	"./campaigns/top-finance-training/tft-streaks.webp": 883,
	"./campaigns/top-finance-training/tft-tracks.webp": 884,
	"./campaigns/top-finance-training/tft-xp-levels.webp": 885,
	"./campaigns/video-thumbs/vthumb-ahmed.webp": 605,
	"./campaigns/video-thumbs/vthumb-ernest.webp": 606,
	"./campaigns/video-thumbs/vthumb-julián.webp": 607,
	"./campaigns/video-thumbs/vthumb-lee.webp": 608,
	"./campaigns/video-thumbs/vthumb-meghan.webp": 609,
	"./campaigns/video-thumbs/vthumb-mihaela.webp": 610,
	"./campaigns/video-thumbs/vthumb-nada.webp": 611,
	"./career-track-certificate.png": 1504,
	"./certificate-of-completion.png": 1853,
	"./cfi.jpg": 1854,
	"./codecademy.jpg": 1855,
	"./contacts.png": 1525,
	"./course-library.png": 1856,
	"./course-preview.jpg": 1857,
	"./coursera-img2.jpg": 1858,
	"./data-camp-comparison.png": 1859,
	"./data-camp-img1-fa.jpg": 1860,
	"./data-camp-img1.jpg": 1861,
	"./data-camp-img2.jpg": 1862,
	"./data-science-fundamentals.png": 1863,
	"./data-science-vs-datacamp.png": 1864,
	"./datacamp-alternative-365-certificate.png": 1865,
	"./datacamp-comparison.png": 1866,
	"./datacamp.jpg": 1867,
	"./dataquest-courses.png": 1868,
	"./dataquest-img2.jpg": 1869,
	"./dataquest-vs-365datascience-courses.jpg": 1870,
	"./dataquest.jpg": 1871,
	"./discover-author_Elitsa.jpg": 1872,
	"./discover-author_Iliya.jpg": 1873,
	"./discover-author_Martin.jpg": 1874,
	"./discover-author_Ned.jpg": 1875,
	"./discover-student_Ah_Lam.jpg": 1876,
	"./discover-student_Anuj_Gupta.jpg": 1877,
	"./discover-student_Goodwin_Akpan.jpg": 1878,
	"./discover-student_Harshita_Sharma.jpg": 1879,
	"./discover-student_José_Alvarez.jpg": 1880,
	"./discover-student_Karen_Ann.jpg": 1881,
	"./discover-student_Maher_Nabeel.jpg": 1882,
	"./discover-student_Michael_Erlihson.jpg": 1883,
	"./discover-student_Richard_Banks.jpg": 1884,
	"./discover-student_Vikesh_Reddy.jpg": 1885,
	"./discover-student_Wilma_Berg.jpg": 1886,
	"./ds-pre-footer-projects.webp": 1887,
	"./ds-signup-bg.webp": 951,
	"./edx.jpg": 1888,
	"./fa/fa-365-logo-small.png": 1693,
	"./fa/fa-about-us-2.jpg": 1889,
	"./fa/fa-about-us-our-vision.jpg": 1467,
	"./fa/fa-about-us.jpg": 1890,
	"./fa/fa-b2b-img1.png": 1487,
	"./fa/fa-b2b-img2.png": 1488,
	"./fa/fa-b2b-img3.png": 1489,
	"./fa/fa-b2b-img4.png": 1490,
	"./fa/fa-b2b-img5.png": 1491,
	"./fa/fa-b2b-img6.png": 1492,
	"./fa/fa-b2b-preview-image-mobile.jpg": 1485,
	"./fa/fa-b2b-preview-image.jpg": 1483,
	"./fa/fa-career-track-certificate.png": 1503,
	"./fa/fa-contacts.jpg": 1524,
	"./fa/fa-courses-banner-mobile.jpg": 1891,
	"./fa/fa-courses-banner.jpg": 1892,
	"./fa/fa-guidelines-wall.jpg": 1893,
	"./fa/fa-homepage-hero-image.webp": 1894,
	"./fa/fa-landing/fa-business-group-waving.webp": 692,
	"./fa/fa-landing/fa-city-shadows-mobile.jpg": 1694,
	"./fa/fa-landing/fa-city-shadows.jpg": 1695,
	"./fa/fa-landing/fa-free-offer-upgrade-bg.jpg": 1696,
	"./fa/fa-landing/fa-free-offer-upgrade-mobile-bg.jpg": 1697,
	"./fa/fa-landing/fa-platform-snaps-mobile.png": 1410,
	"./fa/fa-landing/fa-platform-snaps.png": 1411,
	"./fa/fa-landing/fa-resources-center-offer-bg.jpg": 1698,
	"./fa/fa-landing/fa-resources-center-offer-mobile-bg.jpg": 1699,
	"./fa/fa-landing/fa-signup-mobile.jpg": 1700,
	"./fa/fa-landing/fa-start-learning-bg.jpg": 1701,
	"./fa/fa-landing/fa-start-learning-m-bg.jpg": 1702,
	"./fa/fa-landing/fa-start-learning-m-mobile-bg.jpg": 1703,
	"./fa/fa-landing/fa-start-learning-mobile-bg.jpg": 1704,
	"./fa/fa-landing/fa-students-reviews.png": 1356,
	"./fa/fa-login-bg.jpg": 1895,
	"./fa/fa-pre-footer-homepage.jpg": 1896,
	"./fa/fa-pre-footer-homepage.webp": 1897,
	"./fa/fa-pre-footer-projects.webp": 1898,
	"./fa/fa-pre-footer.webp": 548,
	"./fa/fa-signup-bg.jpg": 1899,
	"./fa/fa-signup-bg.webp": 950,
	"./fa/fa-signup-users.png": 1549,
	"./fa/fa-something-better-bg.jpg": 1900,
	"./fa/fa-you-missed-it-bg.jpg": 1901,
	"./facebook_open_graph.png": 1902,
	"./first-place.png": 1903,
	"./for-business-block.png": 1904,
	"./founder-image.png": 1705,
	"./founder-sign.png": 1706,
	"./free-data-science-month.jpg": 1905,
	"./globuses.png": 1906,
	"./guidelines-mobile.jpg": 1907,
	"./guidelines-wall.jpg": 1908,
	"./hero-campaign-banner-bg.jpg": 1909,
	"./hero-campaign-bg-mobile.jpg": 1910,
	"./hero-campaign-bg.jpg": 1911,
	"./hero-testimonials.jpg": 1912,
	"./home-bg-hero.webp": 1913,
	"./home-v2-bg-hero-mobile.webp": 1914,
	"./home-v2-bg-hero.webp": 1915,
	"./icon-chart-blur.png": 715,
	"./icon-lp-coin.png": 1412,
	"./icon-python-calc.png": 628,
	"./icon-python.png": 1413,
	"./icon-quote-testimonial-story.png": 1916,
	"./icon-quote-testimonials.png": 1917,
	"./icon-quotes.png": 1918,
	"./icon-r-calc.png": 629,
	"./icon-r.png": 714,
	"./icon-video-cc.png": 1919,
	"./join-bg.png": 1920,
	"./landing-page-bg.jpg": 1921,
	"./landing-page-mobile-bg.jpg": 1922,
	"./landing-page-resources-bg.jpg": 1923,
	"./landing-page-resources-mobile-bg.jpg": 1924,
	"./landing/lpage-cards-2.png": 1925,
	"./landing/lpage-career-tracks-2.png": 1926,
	"./landing/lpage-certificates-2.png": 1927,
	"./landing/lpage-coins-2.png": 1928,
	"./landing/lpage-exams-2.png": 1929,
	"./landing/lpage-leaderboard-2.png": 1930,
	"./landing/lpage-newsfeed-2.png": 1931,
	"./landing/lpage-streaks-2.png": 1932,
	"./landing/lpage-xp-levels-2.png": 1933,
	"./linkedIn-learning.jpg": 1934,
	"./live-trainings.jpg": 1935,
	"./login-bg.png": 1936,
	"./lp-instructors.png": 1707,
	"./machine-and-deep-learning-in-python.png": 1937,
	"./module-2-programming-for-data-science.png": 1938,
	"./platform-snaps-mobile.png": 1708,
	"./platform-snaps.png": 1709,
	"./pluralsight.jpg": 1939,
	"./polygons-2.png": 1940,
	"./pre-footer-icons-1920-dark.webp": 540,
	"./pre-footer-icons-1920.webp": 549,
	"./professionals-mobile.png": 1941,
	"./professionals-mobile.webp": 1942,
	"./professionals.png": 1943,
	"./professionals.webp": 1944,
	"./quote.png": 1945,
	"./resource-students.png": 1946,
	"./scholarship-image.png": 1947,
	"./screens-ken.png": 1751,
	"./screens-tina.png": 1752,
	"./second-place.png": 1948,
	"./signup-bg.webp": 1949,
	"./signup-users.png": 1334,
	"./simplilearn.jpg": 1950,
	"./single-polygon-2.png": 1951,
	"./something-better-bg.jpg": 1952,
	"./sprinboard.jpg": 1953,
	"./spring-sale-bg-mobile.jpg": 1954,
	"./spring-sale-bg.jpg": 1955,
	"./start-your-career.webp": 1053,
	"./students-worldwide-mobile.png": 1956,
	"./students-worldwide.png": 1957,
	"./students.png": 1431,
	"./summer-sale-bg-mobile.jpg": 1958,
	"./third-place.png": 1959,
	"./treehouse.jpg": 1960,
	"./types-of-learning.png": 1961,
	"./upsell-bg-mobile.jpg": 1710,
	"./upsell-bg.jpg": 1711,
	"./users-group-big.png": 1435,
	"./users-group-bigger.png": 1476,
	"./v2-home-features.webp": 1712,
	"./webinar.jpg": 1531,
	"./winter-campaign-banner.jpg": 1962,
	"./winter-special-bg.jpg": 1963,
	"./winter-special-mobile-bg.jpg": 1964,
	"./you-missed-it-bg.jpg": 1965
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1003;